import Vue from 'vue';
import _ from 'lodash';
import {
    GET_ALL_ROLE_FOR_EDIT,
    GET_WORKERS_FOR_EDIT_REQUEST,
    GET_WORKERS_FOR_EDIT_SUCCESS,
    GET_WORKERS_FOR_EDIT_FAILURE,
    RESET_STAFF_EDIT_DATA
} from '../mutationTypes';

const state = {
    allRoleList: [],
    allWorkers: [],
    workerLoading: false,
    workPage: 1,
    hasMoreWorker: true,

};

const mutations = {
    [GET_ALL_ROLE_FOR_EDIT](state, list) {
        state.allRoleList = state.allRoleList.concat(_.map(list,
            item => _.pick(item, ['id', 'role'])
        ));
    },
    [GET_WORKERS_FOR_EDIT_REQUEST](state) {
        state.workerLoading = true;
    },
    [GET_WORKERS_FOR_EDIT_SUCCESS](state, res) {
        state.workerLoading = false;

        const {
            page_count: pageCount,
            data
        } =  res;

        if (state.workPage < pageCount) {
            state.workPage += 1;
            state.hasMoreWorker = true;
        } else {
            state.hasMoreWorker = false;
        }
        state.allWorkers = state.allWorkers.concat(data);
    },
    [GET_WORKERS_FOR_EDIT_FAILURE](state) {
        state.workerLoading = false;
        state.hasMoreWorker = false;
    },
    [RESET_STAFF_EDIT_DATA](state) {
        state.allRoleList = [];
        state.allWorkers = [];
        state.workerLoading = false;
        state.workPage = 1;
        state.hasMoreWorker = true;
    }
};

export const actions = {
    getAllRole({ commit }) {
        let page = 1;
        // 循环请求列表
        const rangRoleList = async () => {
            const res = await Vue.$ajax.get('roleList', {
                page,
                page_size: 20
            });

            if (!res.errorType) {
                // 处理数据, 检查是否
                const {
                    data,
                    page_count: pageCount
                } = res;
                commit(GET_ALL_ROLE_FOR_EDIT, data);
                if (page < pageCount) {
                    page += 1;
                    rangRoleList();
                }
            }
        };
        rangRoleList();
    },
    async getWorkersForStaffEdit({ commit }) {
        commit(GET_WORKERS_FOR_EDIT_REQUEST);
        const res = await Vue.$ajax.get('workersList', {
            page: state.workPage,
            pagesize: 20
        });

        if (!res.errorType) {
            commit(GET_WORKERS_FOR_EDIT_SUCCESS, res);
        } else {
            commit(GET_WORKERS_FOR_EDIT_FAILURE);
        }
    },
    resetStaffEdit({ commit }) {
        commit(RESET_STAFF_EDIT_DATA);
    }
};

export default {
    state,
    mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/staffEdit.js